var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fa',{staticClass:"d-inline cursor",attrs:{"icon":['fas', _vm.icon]},on:{"click":function($event){return _vm.orderType()}}})}
var staticRenderFns = []

export { render, staticRenderFns }